// -- Initial State --
const initialState = {
  modalType: null, //
  modalData: null,
  modalState: null, // Additional state for modal UI/behavior
};

// -- Reducer --
export default function modalReducer(state = initialState, action) {
  switch (action.type) {
    case "MODAL_OPEN":
      return {
        modalType: action.payload.modalType,
        modalData: action.payload.modalData || null,
        modalState: action.payload.modalState || null,
      };

    case "MODAL_CLOSE":
      return initialState;

    case "MODAL_UPDATE_TYPE":
      return {
        ...state,
        modalType: action.payload,
      };

    case "MODAL_UPDATE_DATA":
      return {
        ...state,
        modalData: action.payload,
      };

    case "MODAL_UPDATE_STATE":
      return {
        ...state,
        modalState: action.payload,
      };

    case "MODAL_UPDATE_TYPE_AND_DATA":
      return {
        ...state,
        modalType: action.payload.modalType,
        modalData: action.payload.modalData,
      };

    case "MODAL_UPDATE_TYPE_AND_STATE":
      return {
        ...state,
        modalType: action.payload.modalType,
        modalState: action.payload.modalState,
      };

    case "MODAL_UPDATE_DATA_AND_STATE":
      return {
        ...state,
        modalData: action.payload.modalData,
        modalState: action.payload.modalState,
      };

    default:
      return state;
  }
}

// -- Action Creators --

// Open a modal with optional data and state
export const modalOpen = ({
  modalType,
  modalData = null,
  modalState = null,
}) => ({
  type: "MODAL_OPEN",
  payload: { modalType, modalData, modalState },
});

// Close the current modal
export const modalClose = () => ({
  type: "MODAL_CLOSE",
});

// Update individual fields
export const modalUpdateType = (modalType) => ({
  type: "MODAL_UPDATE_TYPE",
  payload: modalType,
});

export const modalUpdateData = (modalData) => ({
  type: "MODAL_UPDATE_DATA",
  payload: modalData,
});

export const modalUpdateState = (modalState) => ({
  type: "MODAL_UPDATE_STATE",
  payload: modalState,
});

// Update pairs of fields
export const modalUpdateTypeAndData = (modalType, modalData) => ({
  type: "MODAL_UPDATE_TYPE_AND_DATA",
  payload: { modalType, modalData },
});

export const modalUpdateTypeAndState = (modalType, modalState) => ({
  type: "MODAL_UPDATE_TYPE_AND_STATE",
  payload: { modalType, modalState },
});

export const modalUpdateDataAndState = (modalData, modalState) => ({
  type: "MODAL_UPDATE_DATA_AND_STATE",
  payload: { modalData, modalState },
});
